var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-pagination',{attrs:{"total-rows":_vm.total,"per-page":_vm.perPage,"limit":25,"aria-controls":"table"},on:{"change":_vm.changePage},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})}
var staticRenderFns = []

export { render, staticRenderFns }